<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Unidad de Medida</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-text-field label="* Nombre" v-model.trim="unidad.nombre" dense outlined></v-text-field>
            <v-text-field label="* Abreviatura" v-model.trim="unidad.abreviatura" dense outlined></v-text-field>

            <v-select
              v-model="umed"
              :items="umedidas"
              :loading="loadingmedidas"
              return-object
              label="* Codigo Servicio Impuestos Nacionales:"
            ></v-select>
          </v-container>
          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" class="green darken-2" dark :disabled="loading || loadingmedidas">
            {{ unidad.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        loadingmedidas: false,
        loading: false,
        dialog: false,
        umedidas: [],
        umed: null,
        msg: '',
        unidad: {
          id: null,
          nombre: '',
          abreviatura: '',
          codigo_SIN: null,
          descripcion_SIN: null,
        },
      };
    },
    components: {},
    watch: {
      umed: function() {
        //window.console.log(this.umed);
        if (!this.umed) return;
        this.unidad.codigo_SIN = this.umed.codigo;
        this.unidad.descripcion_SIN = this.umed.descripcion;
      },
    },
    methods: {
      openmodal(item) {
        this.umed = null;
        this.msg = '';
        this.dialog = true;
        this.unidad.id = null;
        this.unidad.nombre = '';
        this.unidad.abreviatura = '';
        this.unidad.codigo_SIN = null;
        this.unidad.descripcion_SIN = null;
        this.getunidadesmedida('4265269017');
        if (item) {
          this.unidad.id = item.id;
          this.unidad.nombre = item.nombre;
          this.unidad.abreviatura = item.abreviatura;
          this.unidad.codigo_SIN = item.codigo_SIN;
          this.unidad.descripcion_SIN = item.descripcion_SIN;
        }
      },
      getunidadesmedida() {
        //if (this.umedidas.length > 0) return;
        this.loadingmedidas = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/unidadmedida`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data = data.sort((a, b) => {
              let x = parseInt(a.codigo);
              let y = parseInt(b.codigo);
              return x - y;
            });
            data.map((u) => {
              u.codigo = parseInt(u.codigo);
              u.text = `(${u.codigo}) ${u.descripcion}`;
            });
            vue.umedidas = data;
            //window.console.log('',data);
            vue.loadingmedidas = false;
            let um = vue.umedidas.find((x) => x.codigo == vue.unidad.codigo_SIN);
            if (um) vue.umed = um;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingmedidas = false;
          });
      },
      save() {
        this.msg = '';
        if (!this.unidad.nombre) this.msg = 'Ingrese el nombre';
        if (!this.unidad.abreviatura) this.msg = 'Ingrese la abreviatura';
        //if (!this.unidad.codigoSIN) this.msg = 'Seleccione un codigo SIN';
        if (this.msg) return;

        let metodo = 'post';
        if (this.unidad.id) metodo = 'put';
        this.loading = true;
        let vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadmedidas`,
          data: this.unidad,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            //window.console.log('newregunidad', data);
            vue.msg = data;
            vue.$emit('newregunidad', vue.unidad);
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error.response.data.errors[0]);
            vue.loading = false;
            vue.msg = error.response.data.errors[0];
          });
      },
    },
  };
</script>
